import script from "./LayoutII.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutII.vue?vue&type=script&setup=true&lang=js"

import "./LayoutII.vue?vue&type=style&index=0&id=013885f5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-013885f5"]])

export default __exports__